import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import type { OfficeDesk } from '../officeDesk/store'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadOfficeDesk(id: number | string) {
  try {
    const url = withPbx(`users/${id}`)

    const { data } = await http.get<OfficeDesk>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function loadOfficeDesks() {
  try {
    const url = withPbx('users')

    const { data } = await http.get<OfficeDesk[]>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function updateOfficeDesks(inputData: {
  userIds: number[]
  preferences: { name: string; value: any }[]
}) {
  try {
    const url = withPbx('users')

    const { data } = await http.patch(url, inputData)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function deleteOfficeDesks(userIds: number[]) {
  try {
    const url = withPbx(`users`)

    const { data } = await http.delete(url, { params: { userIds } })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
